<template>
  <div>
    <div style="padding: 20px;height: 70px">
      <a-button v-if="isRegister" type="primary" @click="register" v-has="'patient:register'">手动注册</a-button>
      <a-button v-if="isRegister && btnVisible" type="primary" style="margin-left: 10px" @click="registerQrcode" v-has="'patient:register'">扫码注册</a-button>
      <a-upload v-if="isRegister" name="file" :data="{projectId:projectId}" :showUploadList="false" :multiple="false" :headers="tokenHeader" style="margin-left: 8px" :action="importExcelUrl" @change="handleImportExcel">
          <a-button type="primary" v-has="'patient:import'">批量导入注册</a-button>
      </a-upload>
      <slot name="btn">

      </slot>      
      <div style="float: right">
        <a-button style="margin-right: 10px" @click="supperSearchView">高级筛选</a-button>
        <a-radio-group v-model="viewType" >
          <a-radio-button value="1">
            <a-icon type="appstore" />
          </a-radio-button>
          <a-radio-button value="2">
            <a-icon type="bars" />
          </a-radio-button>
        </a-radio-group>
        <a-select style="width: 120px;margin-left: 10px" v-model="queryParam.searchType">
          <a-select-option :value="item.name" v-for="(item,index) in searchTypeList" :key="index">
            {{item.text}}
          </a-select-option>
        </a-select>
        <a-input v-model="queryParam.searchValue" style="width: 200px;margin-left: 5px"></a-input>
        <a-button type="primary" @click="searchQueryMy" style="margin-left: 5px"> 查询</a-button>
        <a-button  @click="searchResetMy" style="margin-left: 5px"> 重置</a-button>
        <a-button type="primary" style="margin-left: 5px" @click="notePatient" v-if="isRegister" v-has="'patient:note'">通知受试者</a-button>
      </div>
    </div>
    <div style="padding: 20px; margin-top: -10px">
      <div v-if="viewType==='1'" style="padding-left: 20px;padding-right: 20px">
        <a-spin :spinning="loading">
          <a-row :gutter="20" style="min-height: 400px">
            <a-col :xxl="6" :lg="8" :sm="12" v-for="(item,index) in dataSource" :key="index" style="margin-bottom: 20px">
              <patient-card :isPeriod="isPeriod" :data="item" @editClick="handleEdit" @viewClick="handleView" :fieldList="fieldList" :isRegister="isRegister"/>
            </a-col>
          </a-row>
          <a-col :span="24" style="text-align: center">
            <a-pagination :show-total="total => `共 ${total} 条`" show-quick-jumper :default-current="1" :pageSize="ipagination.pageSize" :total="ipagination.total" @change="pageChange" />
          </a-col>
        </a-spin>

      </div>
      <div v-else>
        <a-table rowKey="id"

                 size="middle"
                 :columns="columns"
                 :dataSource="dataSource"
                 :pagination="ipagination"
                 :loading="loading"
                 :scroll="{ x: 1200 }"
                 @change="handleTableChange"
        >
            <span slot="action" slot-scope="text, record">
                <a @click="handleView(record)">查看</a>
                     <template v-if="isRegister">
                       <a-divider type="vertical" v-has="'patient:register'"/>
                 <a @click="handleEdit(record)" v-has="'patient:register'">编辑</a>
                     </template>
            </span>
          <span slot="status" slot-scope="text, record, index">
            <status-tag :status="text"></status-tag>
           </span>
        </a-table>
      </div>
    </div>
    <patient-edit ref="patient-edit" :fieldList="fieldList" @ok="modalFormOk" @loadOne="reloadPatient"></patient-edit>    
    <a-drawer
      title="高级筛选"
      :width="'80%'"
      :visible="supperSearchVisible"
      :closable="true"
      @close="handleSupperSearchCancel">
      <a-checkbox-group v-model="queryParam2.centerIdList" class="advanced-row" >
        <a-row>
          <a-col :span="4" class="advanced-label">
            研究中心：
          </a-col>
          <a-col :span="20">
            <a-row>
              <a-col :span="8" v-for="(center,index) in centerList" :key="index">
                <a-checkbox :value="center.center.id">
                  {{center.center.name}}
                </a-checkbox>
              </a-col>
            </a-row>
          </a-col>
        </a-row>
      </a-checkbox-group>
      <a-checkbox-group v-model="queryParam2.userIdList" class="advanced-row">
        <a-row>
          <a-col :span="4" class="advanced-label">
            研究员：
          </a-col>
          <a-col :span="20">
            <a-row>
              <a-col :span="8" v-for="(user,index) in userList" :key="index">
                <a-checkbox :value="user.userId">
                  {{user.realname}}
                </a-checkbox>
              </a-col>
            </a-row>
          </a-col>
        </a-row>
      </a-checkbox-group>
      <!-- <a-checkbox-group v-model="queryParam2.groupIdList" class="advanced-row">
        <a-row>
          <a-col :span="4" class="advanced-label">
            组别：
          </a-col>
          <a-col :span="20">
            <a-row>
              <a-col :span="8" v-for="(item,index) in groupList" :key="index">
                <a-checkbox :value="item.id">
                  {{item.name}}
                </a-checkbox>
              </a-col>
            </a-row>
          </a-col>
        </a-row>
      </a-checkbox-group> -->
      <a-checkbox-group v-model="queryParam2.statusList" class="advanced-row">
        <a-row>
          <a-col :span="4" class="advanced-label">
            受试者状态：
          </a-col>
          <a-col :span="20">
            <a-row>
              <a-col :span="8" v-for="(item,index) in patientStatusList" :key="index">
                <a-checkbox :value="item.value">
                  {{item.text}}
                </a-checkbox>
              </a-col>
            </a-row>
          </a-col>
        </a-row>
      </a-checkbox-group>
      <a-row class="advanced-row" >
        <a-col :span="4"class="advanced-label">
          注册日期：
        </a-col>
        <a-col :span="20">
          <a-range-picker v-model="queryParam2.createTimeList"  valueFormat="YYYY-MM-DD"/>
        </a-col>
      </a-row>
      <a-row class="advanced-row" >
        <a-col :span="4" class="advanced-label">
          通过筛选日期：
        </a-col>
        <a-col :span="20">
          <a-range-picker v-model="queryParam2.passDateList"  valueFormat="YYYY-MM-DD"/>
        </a-col>
      </a-row>
      <a-row class="advanced-row" >
        <a-col :span="4" class="advanced-label">
          终止筛选日期：
        </a-col>
        <a-col :span="20">
          <a-range-picker v-model="queryParam2.noPassDateList"  valueFormat="YYYY-MM-DD"/>
        </a-col>
      </a-row>
      <a-checkbox-group v-model="queryParam2.periodItemIdList" class="advanced-row">
        <a-row>
          <a-col :span="4" class="advanced-label">
            正在随访的周期：
          </a-col>
          <a-col :span="20">
            <a-row>
              <a-col :span="8" v-for="(periodItem,index) in periodItemList" :key="index">
                <a-checkbox :value="periodItem.id">
                  {{periodItem.name}}
                </a-checkbox>
              </a-col>
            </a-row>
          </a-col>
        </a-row>
      </a-checkbox-group>      
      <a-checkbox-group v-if="formSearch" v-model="queryParam2.formIdList" class="advanced-row">
        <a-row>
          <a-col :span="4" class="advanced-label">
            表单：
          </a-col>
          <a-col :span="20">
            <a-row>
              <a-col :span="8" v-for="(form,index) in formList" :key="index" :title="form.description">
                <a-checkbox :value="form.id">
                  {{form.name}}
                </a-checkbox>
              </a-col>
            </a-row>
          </a-col>
        </a-row>
      </a-checkbox-group>
      <a-row class="advanced-row" >
        <a-col :span="4" class="advanced-label">
          基点日期：
        </a-col>
        <a-col :span="20">
          <a-range-picker v-model="queryParam2.baseDateList"  valueFormat="YYYY-MM-DD"/>
        </a-col>
      </a-row>
      <a-row class="advanced-row" :gutter="0">
          <a-col :span="4" class="advanced-label">
          自定义筛选周期：
        </a-col>
            <a-col :span="2" class="advanced-label">
              <a-input-group compact class="search">
                <a-select v-model="queryParam2.periodItemId" style="min-width:120px" placeholder="请选择周期" allow-clear>
                  <a-select-option :value="periodItem.id" v-for="(periodItem, index) in periodItemList" :key="index">
                    {{ periodItem.name }}
                  </a-select-option>
                </a-select>                
              </a-input-group>
            </a-col>
            <a-col :span="18">
              <a-range-picker v-model="queryParam2.periodDateList" valueFormat="YYYY-MM-DD" />
            </a-col>
          </a-row>
          <a-radio-group v-model="queryParam2.rct" class="advanced-row" v-if="projectId=='1781156370223149057'">
  <a-row>
    <a-col :span="4" class="advanced-label">
      RCT入组：
    </a-col>
    <a-col :span="20">
      <a-row>
        <a-col :span="8" v-for="(item,index) in rctStatusList" :key="index">
          <a-radio :value="item.value">
            {{item.text}}
          </a-radio>
        </a-col>
      </a-row>
    </a-col>
  </a-row>
</a-radio-group>
      <!-- <a-row class="advanced-row" v-if="projectId=='1781156370223149057'">
        <a-col :span="4" class="advanced-label">
          RCT入组：
        </a-col>
        <a-col :span="20">
          <a-checkbox  v-model="queryParam2.rct">RCT</a-checkbox>
         
        </a-col>
      </a-row> -->
      <a-row class="advanced-row" v-if="!isRegister">
        <a-col :span="4" class="advanced-label">
          表单提交日期：
        </a-col>
        <a-col :span="20">
          <a-range-picker v-model="queryParam2.submitDateList"  valueFormat="YYYY-MM-DD"/>
        </a-col>
      </a-row>
      <div style="text-align: right;margin-top: 20px">
        <a-button @click="handleSupperSearchCancel">取消</a-button>
        <a-button @click="handleSupperSearchSubmit" type="primary" style="margin-left: 20px">确定</a-button>
      </div>
    </a-drawer>
    <a-modal
      title="扫码注册"
      :width="400"
      :visible="qrcode.visible"
      :footer="null"
      @cancel="qrcodeCancel">
      <div>
        <a-alert show-icon message="扫码注册是绑定当前登录用户为受试者的调查员！" type="info" />
      </div>
      <div style="margin-top: 10px">
        请打开微信【扫一扫】，关注公众号后自动绑定
      </div>
      <div style="text-align: center">
        <img v-if="qrcode.url" :src="qrcode.url" style="width:200px;height:200%"/>

      </div>
      <div style="text-align: center">
        <a-button icon="reload" @click="reloadQrcode">刷新二维码</a-button>
      </div>
      <div style="text-align: right;margin-top: 20px">
        <a-button type="primary" @click="handleQrcodeClose">确定</a-button>
      </div>
    </a-modal>

    <a-modal :title="`通知受试者`" :width="'70%'" :visible="noteView" :confirmLoading="loading"
      @ok="noteOk" okText="推送通知" @cancel="noteView = false">
      <a-row class="spaced-row" style="margin-bottom:16px;">
          <a-col :span="6" class="advanced-label" >
            通知类型：
          </a-col>
          <a-col :span="18">
              <a-radio-group v-model="note.type">
              <a-radio value="1">
                微信推送填写表单
                <a-tooltip placement="topLeft" style="padding-right:2px">
                  <template slot="title">
                    未绑定微信或取消关注的受试者无法推送
                  </template>
                  <a-icon type="info-circle" style="color: red" />
                </a-tooltip>
              </a-radio>
              <a-radio value="2">
                短信通知填写表单
                <a-tooltip placement="topLeft" style="padding-right:2px">
                  <template slot="title">
                    未预留手机号码的受试者无法推送
                  </template>
                  <a-icon type="info-circle" style="color: red" />
                </a-tooltip>
              </a-radio>
              <!-- <a-radio value="4">
                微信推送报告
                <a-tooltip placement="topLeft" style="padding-right:2px">
                  <template slot="title">
                    未绑定微信或取消关注的受试者无法推送
                  </template>
                  <a-icon type="info-circle" style="color: red" />
                </a-tooltip>
              </a-radio> -->
            </a-radio-group>
          </a-col>
      </a-row>
          <a-row class="spaced-row">
          <a-col :span="6" class="advanced-label">
            通知受试者：
          </a-col>
          <a-col :span="18">
              <a-input v-model="note.keyword" style="width: 200px;margin-left: 5px" placeholder="请输入受试者姓名/编号"></a-input>    
              <!-- <a-select v-model="note.patientStatus" placeholder="选择受试者状态" style='min-width: 150px' allow-clear >
                <a-select-option :value="item.value" v-for="(item,index) in patientStatusList" :key="index">
                  {{item.text}}
                </a-select-option>
              </a-select>         -->
              <a-select v-model="note.needPeriodItemId" placeholder="请选择周期" style='min-width: 200px' allow-clear showSearch :filter-option="filterOption">
                <a-select-option :value="periodItem.id" v-for="(periodItem,index) in periodItemList" :key="index">
                  {{periodItem.name}}
                </a-select-option>
              </a-select>
              <a-select v-model="note.periodStatus" placeholder="请选择周期状态" style='min-width: 150px' allow-clear >
                <a-select-option :value="item.value" v-for="(item,index) in periodStatusList" :key="index">
                  {{item.name}}
                </a-select-option>
              </a-select>
          </a-col>
        </a-row>
      <div style="text-align: right">
        <a-button type="primary" @click="searchNote">查询</a-button>
      </div>
      <div class="scrollable-content">
        <a-table rowKey="id"
                 height="300"
                 size="middle"
                 :columns="noteColumns"
                 :dataSource="notePatientList"
                 :pagination="ipagination2"
                 :loading="loading"
                 :scroll="{ y: 300,x:300 }"
                 @change="noteTableChange">          
                 <span slot="status" slot-scope="text, record, index">
            <status-tag :status="text"></status-tag>
           </span>
        </a-table>
      </div>
    </a-modal>

  </div>
</template>

<script>
  import PatientCard from '../PatientCard'
  import StatusTag from '../StatusTag'
  import PatientEdit from '../PatientEdit'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import { CACHE_PROJECT_ID} from '@/constants/project'
  import { getAction,postAction,putAction } from '@/api/manage'
  import Vue from 'vue'
  import {  mapGetters } from 'vuex'
  export default {
    name: 'PatientIndex',
    components: { PatientEdit, StatusTag, PatientCard },
    mixins:[JeecgListMixin],
    props:{
      formSearch:{
        type:Boolean,
        default:false,
      },
      urlList:{
        type:String,
        default:'/patient/patient/list'
      },
      isRegister:{
        type:Boolean,
        default:true
      },
      isPeriod:{
        type:Boolean,
        default:false
      },

      parentBaseQueryParam:{
        type:Object,
        default:()=>{
          return {}
        }
      }
    },
    data(){
      return{
        btnVisible:false,
        projectId: Vue.ls.get(CACHE_PROJECT_ID),
        loading:false,
        viewType:'1',
        queryParam:{
          searchType:'name',
          searchValue:'',
        },
        queryParam2:{},
        ipagination:{
          current: 1,
          pageSize: 12,
          pageSizeOptions: ['12', '18', '24'],
          showTotal: (total, range) => {
            return range[0] + "-" + range[1] + " 共" + total + "条"
          },
          showQuickJumper: true,
          showSizeChanger: true,
          total: 0
        },
        ipagination2:{
          current: 1,
          pageSize: 12,
          pageSizeOptions: ['12', '18', '24'],
          showTotal: (total, range) => {
            return range[0] + "-" + range[1] + " 共" + total + "条"
          },
          showQuickJumper: true,
          showSizeChanger: true,
          total: 0
        },
        searchTypeList:[
          {name:'name',text:'受试者姓名'},
          {name:'patient_num',text:'受试者编号'},
          {name:'idcard',text:'身份证号'},
          // {name:'eid',text:'EID'},
        ],
        disableMixinCreated:true,
        url:{
          list:this.urlList,
        },
        concernIndicatorList:[],
        trendIndicatorList:[],
        fieldList:[],
        periodStatusList:[{value:"2",name:"可随访"},{value:"3",name:"已过期"}],        
        baseColumns:[
          {
            title:'受试者编号',
            fixed:'left',
            align: 'center',
            width: 120,
            ellipsis: true,
            dataIndex: 'patientNum'
          },
          // {
          //   fixed:'left',
          //   title:'EID',
          //   align: 'center',
          //   width: 100,
          //   ellipsis: true,
          //   dataIndex: 'eid'
          // },
          {
            title:'受试者姓名',
            align: 'center',
            fixed:'left',
            width: 120,
            ellipsis: true,
            key: 'name',
            dataIndex: 'name'
          },
          {
            title:'受试者信息',
            children:[
              {
                title:'性别',
                align: 'center',
                width: 80,
                ellipsis: true,
                key: 'sex',
                dataIndex: 'sex_dictText',
              },
              {
                title:'年龄',
                align: 'center',
                width: 80,
                ellipsis: true,
                dataIndex: 'age'
              },

            ]
          },
          {
            title:'入组信息',
            children:[
              {
                title:'研究中心',
                align: 'center',
                width: 100,
                ellipsis: true,
                dataIndex: 'centerName'
              },
              {
                title:'研究员',
                align: 'center',
                width: 100,
                ellipsis: true,
                dataIndex: 'personName'
              },
              {
                title:'状态',
                align: 'center',
                width: 100,
                ellipsis: true,
                scopedSlots: {customRender: 'status'},
                dataIndex: 'status'
              },
              {
                title:'注册日期',
                align: 'center',
                width: 100,
                ellipsis: true,
                dataIndex: 'createTime'
              },
              {
                title:'通过筛选日期',
                align: 'center',
                width: 140,
                ellipsis: true,
                dataIndex: 'passDate'
              },
              // {
              //   title:'组别',
              //   align: 'center',
              //   width: 100,
              //   ellipsis: true,
              //   dataIndex: 'groupName'
              // },
              {
                title:'基点日期',
                align: 'center',
                width: 100,
                ellipsis: true,
                dataIndex: 'baseDate'
              },
            ]
          },
        ],
        supperSearchVisible:false,
        noteView:false,
        note:{
          projectId:this.projectId,
          type:'1',
          keyword:'',
          // needPeriodItemId:'',
        },
        notePatientList:[],
        userList:[],
        centerList:[],
        periodItemList:[],
        groupList:[],
        formList:[],
        patientStatusList:[
          {value:'1',text:'筛选期'},
          {value:'2',text:'随访期'},
          {value:'3',text:'终止筛选'},
          {value:'4',text:'终止随访'},
          {value:'5',text:'随访完成'},
        ],
        rctStatusList:[
        { value: '1', text: '待定' },
        { value: '2', text: '完成' },
        { value: '3', text: '未完成' },
      ],
        qrcode:{
          visible:false,
          url:''
        },
        noteColumns:[
          {
            title:'受试者编号',
            fixed:'left',
            align: 'center',
            width: 120,
            ellipsis: true,
            dataIndex: 'patientNum'
          },
          {
            title:'受试者姓名',
            align: 'center',
            fixed:'left',
            width: 120,
            ellipsis: true,
            key: 'name',
            dataIndex: 'name'
          },
          {
                title:'性别',
                align: 'center',
                width: 80,
                ellipsis: true,
                key: 'sex',
                dataIndex: 'sex_dictText',
              },
              {
                title:'年龄',
                align: 'center',
                width: 80,
                ellipsis: true,
                dataIndex: 'age'
              },
          {
                title:'研究中心',
                align: 'center',
                width: 150,
                ellipsis: true,
                dataIndex: 'centerName'
              },
              {
                title:'研究员',
                align: 'center',
                width: 120,
                ellipsis: true,
                dataIndex: 'personName'
              },
              {
                title:'状态',
                align: 'center',
                width: 100,
                ellipsis: true,
                scopedSlots: {customRender: 'status'},
                dataIndex: 'status'
              },
              {
                title:'注册日期',
                align: 'center',
                width: 150,
                ellipsis: true,
                dataIndex: 'createTime'
              }
        ],
      }
    },
    computed:{
      columns(){
        const columns = JSON.parse(JSON.stringify(this.baseColumns))
        if(this.fieldList.length>0){
          this.fieldList.forEach(item=>{
            if(item.type==='2'){
              columns[3].children.push({
                title:item.name,
                align: 'center',
                width: 100,
                ellipsis: true,
                dataIndex:'defineField.'+ item.id
              })
            }
          })
        }
        if(this.concernIndicatorList.length>0){
          this.concernIndicatorList.forEach(item=>{
            columns.push({
              title:item.name,
              align: 'center',
              width: 100,
              ellipsis: true,
              dataIndex: item.id
            })
          })
        }
        columns.push({
          title: '操作',
          dataIndex: 'action',
          width: 100,
          fixed:'right',
          scopedSlots: {customRender: 'action'},
          align: 'center'
        })
        return columns
      },
       importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/patient/patient/importExcel`;
      }
    },
    watch:{
      parentBaseQueryParam:{
        handler(){
          this.handleBaseQueryParam()
        },
        deep:true
      }
    },
    mounted(){
      this.handleBaseQueryParam()
      this.loadSearchData()
      getAction('/project/projectPatientField/list',{projectId:this.projectId}).then(res=>{
        if(res.success){
          this.fieldList = res.result
          this.fieldList.forEach(item=>{
            if(item.type==='2'){
              this.searchTypeList.push({
                name:item.id,
                text:item.name
              })
            }
          })
        }
      })
      getAction('/project/projectConcernIndicator/list',{projectId:this.projectId}).then(res=>{
        if(res.success){
          this.concernIndicatorList=res.result
        }
      })
      getAction('/project/projectTrendIndicator/list',{projectId:this.projectId}).then(res=>{
        if(res.success){
          this.trendIndicatorList=res.result
        }
      })
       getAction('/management/project/listAll',{id:this.projectId,wechat:"1"}).then(res=>{
          if(res.success&&res.result.length>0){
            this.btnVisible=true
          }else{
             this.btnVisible=false
          }
        })
    },
    activated() {    
      console.log('activated')
      this.reloadPatient()
    },
    methods:{
      ...mapGetters(["userInfo"]),
      handleBaseQueryParam(){
        const baseQueryParam = Object.assign({},this.parentBaseQueryParam)
        baseQueryParam.projectId = this.projectId
        this.baseQueryParam = baseQueryParam
        this.searchQueryMy()
      },
      handleSupperSearchSubmit(){
        this.$set(this.queryParam,'searchValue',null)
        this.$set(this.queryParam,'searchType','name')
        this.$set(this.queryParam,'supper',JSON.stringify(this.queryParam2))
        this.loadData();
        this.handleSupperSearchCancel()
      },
      handleSupperSearchCancel(){
        this.supperSearchVisible = false
      },
      supperSearchView(){
        // this.resetSupperParams()
        this.supperSearchVisible = true
      },
      resetSupperParams(){
        this.$set(this.queryParam2,'centerIdList',[])
        this.$set(this.queryParam2,'userIdList',[])
        this.$set(this.queryParam2,'groupIdList',[])
        this.$set(this.queryParam2,'statusList',[])
        this.$set(this.queryParam2,'createTimeList',[])
        this.$set(this.queryParam2,'passDateList',[])
        this.$set(this.queryParam2,'noPassDateList',[])
        this.$set(this.queryParam2,'periodItemIdList',[])
        this.$set(this.queryParam2,'baseDateList',[])
        this.$set(this.queryParam2,'formIdList',[])
        this.$set(this.queryParam2,'rct',null)
        this.$set(this.queryParam,'supper',"")
        this.$set(this.queryParam, 'searchType', 'name')
        this.$set(this.queryParam, 'searchValue', null)
      },
      loadSearchData(){
        getAction('/project/center/listAll',{projectId:this.projectId}).then(res=>{
          if(res.success){
            this.centerList = res.result
          }
        })
        getAction('/project/projectUser/listAll',{projectId:this.projectId}).then(res=>{
          if(res.success){
            this.userList = res.result
          }
        })
        getAction('/project/projectPeriodItem/list',{projectId:this.projectId,halfway:'0'}).then(res=>{
          if(res.success){
            this.periodItemList=res.result
          }
        })
        getAction('/project/projectGroup/list',{projectId:this.projectId}).then(res=>{
          if(res.success){
            this.groupList = res.result
          }
        })
        if(this.formSearch){
          getAction('/project/projectForm/listAll',{projectId:this.projectId}).then(res=>{
            if(res.success){
              this.formList=res.result
            }
          })
        }
      },
      searchQueryMy(){
        // this.resetSupperParams()
        this.searchQuery()
      },
      searchResetMy(){
        this.queryParam.searchValue = ''
        this.resetSupperParams()
        this.loadData(1);
      },

      register(){
        this.$refs['patient-edit'].edit({projectId:this.projectId})
      },
      notePatient(){
        this.noteView = true
      },
      searchNote(){
        this.note.projectId = this.projectId
        this.note.pageSize = this.ipagination2.pageSize
        this.note.pageNo = this.ipagination2.current
        if(!this.note.needPeriodItemId){
          this.$message.warning("请选择通知受试者的周期")
          return
        }
        
        getAction('/patient/patient/note/list',this.note).then(res=>{
        if(res.success){
          this.notePatientList = res.result.records
          this.ipagination2.total = res.result.total 
          this.ipagination2.current = res.result.current
        }
      })
      },
      noteOk(){
        if(this.ipagination2.total===0){
          this.$message.warning("请先筛选需要通知的受试者")
          return
        }
        if(!this.note.needPeriodItemId){
          this.$message.warning("请选择通知受试者的周期")
          return
        }
        this.$confirm({
          title: '发送表单填写通知',
          content: (<div>
            <p>您确定要向{this.ipagination2.total}个受试者发送通知吗？</p>
          </div>),
          centered: false,
          onOk: () => {
            this.note.projectId = this.projectId            
            this.loading = true
            getAction('/patient/patient/note',this.note).then(res=>{
              if(res.success){
                this.$message.info("已发起推送")
              }
            }).finally(()=>{
              this.loading = false
            })
          },
        })
      },
      noteTableChange(pagination, filters, sorter) {
        //分页、排序、筛选变化时触发
        //TODO 筛选        
        this.ipagination2 = pagination;
        this.searchNote();
      },
      registerQrcode(){
        this.qrcode.visible = true
        this.reloadQrcode()
      },
      qrcodeCancel(){
        this.qrcode.visible = false
        this.searchQuery()
      },
      handleQrcodeClose(){
        this.qrcodeCancel()
      },
      reloadQrcode(){
        getAction('/wechat/getForeverTicketPersonId',{projectId:this.projectId,personId:this.userInfo().id}).then(res=>{
          if(res.success){
            this.qrcode.url = res.result
            this.qrcode.visible = true
          }else{
            return this.$message.error(res.message)
          }
        })
      },
      reloadPatient(){
      //重新加载当前受试者信息
        const patientNum = sessionStorage.getItem('patientNumScroll');
        if(patientNum){
          let patient = this.dataSource.find(p => p.patientNum === patientNum);
          if(!patient){
            return
          }
          getAction('/patient/patient/list', { projectId: this.projectId,searchType: 'patient_num',searchValue: patientNum }).then(res => {
            if (res.success && res.result && res.result.records) {
              if(res.result.records.length>0){              
                this.dataSource = this.dataSource.map(item => {
                  if (item.patientNum === patientNum) {
                    return res.result.records[0];
                  }
                  return item;
                });
              }else{//找不到当前受试者，则移除sessionStorage中的记录，并刷新表格数据。
                this.dataSource = this.dataSource.filter(item => item.patientNum !== patientNum);
                sessionStorage.removeItem('patientNumScroll');
              }
            }
          })
        }
      },
      handleView(record){
        console.log('handleView patientNum:' + record.patientNum)
        sessionStorage.setItem('patientNumScroll', record.patientNum);
        this.$emit('handleView',record)
      },
      handleEdit(record){
        sessionStorage.setItem('patientNumScroll', record.patientNum);
        this.$refs['patient-edit'].edit(record)
      },
      pageChange(page,pageSize){
        this.ipagination.current = page
        this.ipagination.pageSize = pageSize
        this.loadData()
      },
      loadDataCallback(){
        this.dataSource.forEach(record=>{
          this.$set(record,'defineField',record.defineField ||{})
          if(record.fieldValueList){
            record.fieldValueList.forEach(item=>{
              this.$set(record.defineField,item.fieldId,item.value)
            })
          }
        })
        this.dataSource.forEach(item=>{
          if(!item.indicatorList){
            return
          }
          item.indicatorList.forEach(indicator=>{
            this.$set(item,indicator.id,indicator.value)
          })
        })
      },
      filterOption(input, option) {
        return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      },
    }
  }
</script>

<style scoped lang="less">
  .advanced-row{
    width: 100%;
    margin-bottom: 10px;
  }
  .advanced-label{
    text-align: right;
  }
</style>